module.exports = __webpack_public_path__ + "static/assets/31192a810938684f7381d69dba6a9ad6.png";